import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate} from "../util/helpers";
import {toast} from "react-toastify";

export default function UserBlocks() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") || "1";
    const blockerId = searchParams.get("blockerId") || "";
    const blockedId = searchParams.get("blockedId") || "";

    const requestData = () => {
        const params = { page };
        if (blockerId) params.blockerId = blockerId;
        if (blockedId) params.blockedId = blockedId;

        axios.get(`/admin/v1/member/blocks`, { params })
            .then((res) => {
                setPager(res.data);
                setResults(res.data.content || []);
            });
    };

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage("1");
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, blockerId, blockedId]);

    const deleteBlock = (blockId) => {
        if (!window.confirm("해당 차단 관계를 삭제하시겠습니까?")) {
            return;
        }
        axios.delete(`/admin/v1/member/blocks/${blockId}`)
            .then(() => {
                toast.success("차단 관계가 삭제되었습니다.");
                requestData();
            });
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 &gt; 차단 내역</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>차단한 회원 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: '150px', marginRight: '15px'}}
                                                    value={blockerId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("blockerId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                    placeholder="차단한 회원 ID"
                                                />

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>차단당한 회원 ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control float-right"
                                                    style={{width: '150px', marginRight: '15px'}}
                                                    value={blockedId}
                                                    onChange={(e) => {
                                                        searchParams.set("page", "1");
                                                        searchParams.set("blockedId", e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            search();
                                                        }
                                                    }}
                                                    placeholder="차단당한 회원 ID"
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-info float-right"
                                                    style={{width: '80px', marginRight: '10px'}}
                                                    onClick={search}
                                                >
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>차단ID</th>
                                                    <th>차단한 회원</th>
                                                    <th>차단당한 회원</th>
                                                    <th>차단일</th>
                                                    <th>관리</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {results && results.map(item => (
                                                    <tr key={item.blockId}>
                                                        <td>{item.blockId}</td>
                                                        <td>
                                                            <div>
                                                                <a href={`/page/users/detail?userId=${item.blockerId}`}
                                                                   target="_blank"
                                                                   rel="noopener noreferrer">
                                                                    {item.blockerId}: {item.blockerNickname || '-'}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <a href={`/page/users/detail?userId=${item.blockedId}`}
                                                                   target="_blank"
                                                                   rel="noopener noreferrer">
                                                                    {item.blockedId}: {item.blockedNickname || '-'}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>{formatDate(item.createdAt)}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={() => deleteBlock(item.blockId)}
                                                            >
                                                                삭제
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {pager && <Pagination pager={pager} setPage={setPage} />}
                    </section>
                </div>
            </div>
        </div>
    );
}
